/**
 * Mendeteksi error jaringan/server (bukan auth).
 * Jika true: JANGAN logout user (hindari lockout saat server down).
 */
export function isNetworkOrServerError(error) {
  if (!error) return false;
  if (!error.response) {
    const code = error.code || '';
    const message = (error.message || '').toLowerCase();
    return (
      code === 'ERR_NETWORK' ||
      code === 'ECONNABORTED' ||
      code === 'ECONNREFUSED' ||
      code === 'ETIMEDOUT' ||
      code === 'ENOTFOUND' ||
      message.includes('network error') ||
      message.includes('failed to fetch')
    );
  }
  if (error.response?.status >= 500) return true;
  if ([408, 502, 503, 504].includes(error.response?.status)) return true;
  return false;
}

/**
 * Mendeteksi 403 karena akun dinonaktifkan (admin.aktif = 'tidak').
 */
export function isInactiveAccountError(error) {
  return (
    error?.response?.status === 403 &&
    error?.response?.data?.aktif === 'tidak'
  );
}

/**
 * Mendeteksi error cooldown refresh token (refresh gagal karena jaringan).
 */
export function isRefreshCooldownError(error) {
  return (
    error?.code === 'REFRESH_COOLDOWN' || error?.isRefreshCooldown === true
  );
}
